import { useState } from "react";

import { Button } from "@/shared/ui/button";

import { Modal } from "@/shared/ui/Modal";
import { Textarea } from "@/shared/ui/textarea";
import { useBroadcastToLeads } from "@/entities/notification/api";

export const BroadcastToLeadsModal = () => {
  const { mutateAsync } = useBroadcastToLeads();
  const [value, setValue] = useState("");

  const handleBroadcast = async () => {
    await mutateAsync({ message: value });
  };

  return (
    <Modal>
      <Modal.Trigger>Рассылка лидам</Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Рассылка лидам</Modal.Title>
        <Textarea
          placeholder="Текст сообщения"
          onChange={(e) => setValue(e.target.value)}
          value={value}
          className="text-textColor"
        />
        <Button onClick={handleBroadcast}>Отправить</Button>

        <Modal.Close />
      </Modal.Content>
    </Modal>
  );
};
